import {
  getApiUrl,
  getPublicApiUrl,
  AXIOS_AUTHED,
  AXIOS_UNAUTHED,
  DEFAULT_PAGEABLE,
  getAxiosInstanceByLoginMode
} from './shared';
import { constructPageString } from '../../utils/api-util';
import { isStringNumber, serializeAsQueryString } from '../../utils/utils';

const CUSTOMER_BASE_URL = `${getApiUrl()}/customers`;

const DEFAULT_SEARCH = {
  search: null,
  branchIds: null,
  branchRouteNumbers: null,
  routeNumbers: null,
  branchRouteCustomerIds: null,
  customerNames: null,
  customerNumbers: null,
  customerIds: null,
  expiresAfter: null,
  expiresBefore: null,
  contractExpiresAfter: null,
  contractExpiresBefore: null,
  responsibleEmployee: null,
  statuses: [],
  dayId: null,
  mustHaveContract: false
};

const search = (pageable = DEFAULT_PAGEABLE, criteria = DEFAULT_SEARCH) => {
  const pageString = constructPageString(pageable);
  const queryString = buildQueryString(criteria);
  return getAxiosInstanceByLoginMode().get(
    `${CUSTOMER_BASE_URL}?${pageString}&${queryString}`
  );
};

const getOne = (branchId, routeNumber, customerId) => {
  return AXIOS_AUTHED.get(
    `${getApiUrl()}/branches/${branchId}/routes/${routeNumber}/customers/${customerId}`
  );
};

const getByBrcId = (brcId) => {
  return AXIOS_AUTHED.get(`${getApiUrl()}/customers/${brcId}`);
};

const count = (criteria) => {
  return getAxiosInstanceByLoginMode().get(
    `${CUSTOMER_BASE_URL}/count?${buildQueryString(criteria)}`
  );
};

const getByBranchId = (branchId) => {
  return AXIOS_AUTHED.get(`${CUSTOMER_BASE_URL}?branchIds=${branchId}`);
};

const getBySecret = (secret) => {
  return AXIOS_UNAUTHED.get(`${getPublicApiUrl()}/customers/${secret}`);
};

const patchCustomerBasePrice = (customerKey, basePrice) => {
  return AXIOS_AUTHED.patch(`${CUSTOMER_BASE_URL}`, {
    branchRouteCustomerId: customerKey,
    renewalPriceIncrease: basePrice
  });
};

const buildQueryString = (criteria) => {
  const key = isStringNumber(criteria.search)
    ? 'customerNumbers'
    : 'customerName';
  return serializeAsQueryString(
    {
      ...criteria,
      search: undefined, // delete this one
      [key]: criteria.search
    },
    true
  );
};

export {
  search,
  getOne,
  getByBrcId,
  count,
  getByBranchId,
  getBySecret,
  patchCustomerBasePrice
};
